var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@opala-ds/react";
import { useHistory } from "react-router-dom";
export default function OptionCard(_a) {
    var title = _a.title, icon = _a.icon, router = _a.router;
    var history = useHistory();
    return (_jsxs("div", __assign({ onClick: function () { return history.push(router); }, className: "flex flex-row items-center justify-between gap-2 cursor-pointer bg-[#F9FCFF] border border-[#BFBFBF] rounded-lg p-4" }, { children: [_jsxs("div", __assign({ className: "flex flex-row items-center gap-3" }, { children: [_jsx(Icon, { name: icon, size: 24, color: "#262626" }), _jsx("span", __assign({ className: "text-sm font-semibold" }, { children: title }))] })), _jsx(Icon, { name: "ChevronRight", size: 24, color: "#262626" })] })));
}
